import breakpoints from '../data/breakpoints';
import stateClasses from '../data/stateClasses';

export default class GoogleMap {

	constructor(el, initialLocations = []) {
		this.el = el;
		this.markers = []; // stores the marker instances
		this.mapEl = el.querySelector('.js-google-map-canvas');
		this.mobileInfoWindow = this.el.querySelector('.js-google-map-mobile-info-window');

		this.settings = {
			autoSizeMap: true,
		}

		this.mapOptions = {
			zoom: this.el.getAttribute('map-zoom') || 13,
			image: false,
			scrollwheel: false,
			mapId: WP.gmaps_map_id,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			clickableIcons: false,
		};

		this.createMap(initialLocations);
	}

	debug(...message) {
		if (!this.debugMode) return;
			
		if (message.length > 1) {
			console.log('GoogleMap:', ...message);
		} else {
			console.log('GoogleMap:', message[0]);
		}
	}

	createMap(initialLocations) {

		// initialise map
		this.map = new google.maps.Map(this.mapEl, this.mapOptions);

		// initialise submodules
		this.infoWindow = new google.maps.InfoWindow();
		this.markerBounds = new google.maps.LatLngBounds();

		// close infowindow on custom close button click
		this.el.addEventListener('click', e => {
			if (e.target.closest('.js-map-infowindow-close-button')) {
				this.infoWindow.close();
			}
		});

		// close infowindow on click outside markers and infowindows
		this.el.addEventListener('click', e => {
			if (!e.target.closest('.yNHHyP-marker-view')
				&& !e.target.closest('.gm-style-iw-d')
				&& !e.target.closest('.js-google-map-mobile-info-window')
			) {
				this.closeInfoWindow();
				this.resetMarkerStates();
			}
		});

		// close mobile infowindow on custom close button click
		this.mobileInfoWindow.addEventListener('click', e => {
			if (e.target.closest('.js-map-infowindow-close-button')) {
				this.closeInfoWindow();
				this.resetMarkerStates();
			}
		});

		// create the initial markers
		if (initialLocations.length > 0) {
			this.addMarkers(initialLocations);
		}

		// center the map
		this.setCenter();
	}

	addMarkers(locations) {
		locations.forEach(location => {
			this.addMarker(location);
		});

		// fit the map to the markers if needed
		if (this.markers.length > 1 && this.settings.autoSizeMap === true) {
			this.map.fitBounds(this.markerBounds);
		}
	}

	addMarker(location) {

		// create a marker position lat/lng object
		const markerPosition = new google.maps.LatLng(location.latitude, location.longitude);

		// define the marker options
		const markerOptions = {
			position: markerPosition,
			map: this.map,
		};
		
		// add the image
		const markerImage = document.createElement('img');
		if (location.pinImageSrc) {
			markerImage.src = location.pinImageSrc;
			markerOptions.content = markerImage;
			markerOptions.content.dataset.defaultSrc = location.pinImageSrc;
			markerOptions.content.dataset.activeSrc = location.activePinImageSrc;
		}

		// initialise the marker
		const marker = new google.maps.marker.AdvancedMarkerElement(markerOptions);

		// add the CSS class
		marker.content.classList.add('animate-bounce');

		// set the type
		if (location.type) {
			marker.type = location.type;
		}

		// store it in the array within the instance
		this.markers.push(marker);

		// open the popup window on click
		google.maps.event.addListener(marker, 'click', this.handleMarkerClick.bind(this, marker, location));

		// extend the map bounds if needed
		if (this.settings.autoSizeMap === true) {
			this.markerBounds.extend(markerPosition);
		}
	}

	removeMarkers(type = 'all') {

		// remove each marker from the map
		for (let i = 0; i < this.markers.length; i++) {
			if (type === 'all' || this.markers[i].type === type) {
				this.markers[i].setMap(null);
				this.markers[i] = null;
			}
		}

		// remove empty markers from the array
		this.markers = this.markers.filter(marker => marker !== null);
	}

	resetMarkerStates() {
		this.markers.forEach(marker => {

			// reset the image
			marker.content.src = marker.content.dataset.defaultSrc;

			// reset the z-index
			marker.zIndex = 1;
		});
	}

	handleMarkerClick(marker, location) {

		// reset all other markers
		this.resetMarkerStates();

		// set the active image
		marker.content.src = location.activePinImageSrc;

		// set the z-index
		marker.zIndex = 99999;

		if (window.innerWidth <= breakpoints['responsive-map']) {
			this.mapEl.scrollIntoView();
		}

		this.showInfoWindow(marker, location.content);
	}

	showInfoWindow(marker, content) {

		if (window.innerWidth > breakpoints['responsive-map']) {
			this.debug('showing desktop infowindow');
			this.infoWindow.setContent(content);
			this.infoWindow.open(this.map, marker);
		} else {
			this.debug('showing mobile infowindow');
			this.mobileInfoWindow.innerHTML = content;
			this.mobileInfoWindow.classList.add(stateClasses.isActive);
		}
	}

	closeInfoWindow() {
		this.infoWindow.close();
		this.mobileInfoWindow.classList.remove(stateClasses.isActive);
	}

	setCenter() {
		if (this.markers.length > 0) {
			this.map.setCenter(this.markers[0].position);
		}
	}
}